export const PricingRule = {
  AND: "and",
  OR: "or",
} as const;
export type PricingRule = (typeof PricingRule)[keyof typeof PricingRule];
